export const REGISTER_API ='register/'
export const LOGIN_API ='login/'
export const FORGOT_PASSWORD_API ='forgotEmployeePassword/'
export const RESET_PASSWORD_API ='resetEmployeePassword/'

export const EMPLOYEE_INVITES_API ='employeeinvite/'